import { Component, EventEmitter, Injector, Input, Output, ViewChild, OnInit } from '@angular/core';
import { GrooveRecommendationService } from '../../service/GrooveRecommendationService';
import { GrooveRecommendation } from '../../details/GrooveRecommendation';
import { UnitSystem } from '../../details/UnitSystem';
import { ASStandardOringSizesService } from '../../service/ASStandardOringSizesService';
import { HomeComponent } from '../home/home.component';
import { InputLimitationService } from '../../service/InputLimitationService';
import { NgForm } from '@angular/forms';
import { FormService } from '../../service/FormService';
import { DataToSaveService } from '../../service/data-to-save.service';
import { ImportService } from '../../service/import.service';
import { TrackingService } from '../../service/tracking.service';
import { Router, NavigationStart } from '@angular/router';
import {any} from "codelyzer/util/function";
import {RecommendationType} from "../header/header.component";
import {AuthGuard} from "../../service/auth-guard.service";
import {OringRecommendationComponent} from "../oring-recommendation/oring-recommendation.component";


@Component({
  selector: 'app-groove-recommendation',
  templateUrl: './groove-recommendation.component.html',
  styleUrls: ['./groove-recommendation.component.css'],
  providers: [GrooveRecommendationService, InputLimitationService, FormService]
})
export class GrooveRecommendationComponent implements OnInit {

  @Input() measurementUnit;
  @Input() ASStandardOring;
  @ViewChild('grooveForm') form;
  private grooveRecommendationList: Array<GrooveRecommendation>;
  private oringRecommendationListJis;
  options = {
    placeholder: '-Custom',
    minimumResultsForSearch: Infinity
  };
  ASStandardOringSizes;
  selectedASStandardOringSize;
  specialtiesSelected;
  @Output() oringRecommendationEmiter = new EventEmitter();

  oringInputs;
  oringDefaults = {
    oringSizeCs: '',
    oringSizeCsTol: '',
    oringSizeID: '',
    oringSizeIDTol: ''
  };
  selectEvent;
  clickInterval;
  parentComponent;
  grooveRecErrorMsg: any = false;
  imageLabels = {
    id: 'ID',
    cs: 'CS'
  };
  oringInputLimitations;
  storageSet = false;
  groveRecommendationType = 'as';
  static GroveRecommendationType = 'as';

  constructor(private grooveRecommendationService: GrooveRecommendationService,
              private aSStandardOringSizesService: ASStandardOringSizesService,
              private inputLimitationService: InputLimitationService,
              private inj: Injector, private importService: ImportService,
              private dataToSaveService: DataToSaveService, private trackingService: TrackingService,
              private formService: FormService, private router: Router) {
    this.parentComponent = this.inj.get(HomeComponent);
    this.getData();
  }

  ngOnInit() {
    this.inputLimitationService.getOringLimitations().subscribe(res => this.oringInputLimitations = res);
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(() => {
        if (this.router.url === '/home' ) {
          this.dataToSaveService.setOringInputs(this.oringDefaults, this.getAsStringValue());
          this.dataToSaveService.setActiveSections(this.parentComponent.recommendations);
        }
      });
    this.importService.getImportEmitter().subscribe((importResults) => {
      let recommendationType = importResults[6][1];
      if(!recommendationType) {
        recommendationType = importResults[10][1];
      }
      this.getImportedData(importResults[3], recommendationType);
    });
  }

  getAsStringValue() {
    if (Number(this.specialtiesSelected) >= 0) {
      return this.specialtiesSelected;
    }
    return '-CUSTOM';
  }

  getOringLimitations (measurementUnit?, calculated?: boolean) {
    if (measurementUnit) {
      this.measurementUnit = measurementUnit;
    }
    const data = this.oringInputLimitations;
    if (calculated || !data) return;
    this.oringInputs = data.find(item => {
      return UnitSystem.getTypeByUnit(this.measurementUnit) === item.unit;
    });
    this.oringDefaults = {
      oringSizeCs: this.oringInputs.oringSizeCs.default.toFixed(this.getFixedCount()),
      oringSizeCsTol: this.oringInputs.oringSizeCsTol.default.toFixed(this.getFixedCount()),
      oringSizeID: this.oringInputs.oringSizeID.default.toFixed(this.getFixedCount()),
      oringSizeIDTol: this.oringInputs.oringSizeIDTol.default.toFixed(this.getFixedCount())
    };
  }

  setRange(inputName: string, type: string) {
    if (this.oringInputs && this.oringInputs[inputName]) {
      return this.oringInputs[inputName][type];
    }
    return;
  }

  getData() {
    const path = this.dataToSaveService.getPaths();
    if (path.length > 0 && path[path.length - 1] === 'saved-files' &&
      this.dataToSaveService.getActiveSections() &&
      this.dataToSaveService.getActiveSections()['activateGroove']) {
      this.parentComponent.recommendations.activateGroove = true;
    }
    this.grooveRecommendationService.getGrooveRecommendation().subscribe(res => {
      this.grooveRecommendationList = res;
    });
    this.grooveRecommendationService.getOringRecommendationJis().subscribe(res => {
      this.oringRecommendationListJis = res;
    });
    this.aSStandardOringSizesService.getASStandardOringSizes().subscribe(res => {
      this.aSStandardOringSizesService.oringSizesData = res.filter(item => item['ID-M'] !== '');
      this.ASStandardOringSizes = this.getASStandardOringSizesData(this.aSStandardOringSizesService.oringSizesData);
      this.getSavedData();
    });
    this.aSStandardOringSizesService.getASStandardOringSizesJis().subscribe(res => {
      this.aSStandardOringSizesService.oringSizesJisData = res;
    })
  }

  private getASStandardOringSizesData(oringSizesData) {
    const ASStandardOringSizes = oringSizesData.map((item, index) => {
      item.id = index;
      item.text = item['English(inch)'];
      return item;
    });
    ASStandardOringSizes.unshift({id: '', text: ''});
    return ASStandardOringSizes;
  }

  changeStandardOringSizeType() {
    GrooveRecommendationComponent.GroveRecommendationType = this.groveRecommendationType;
    OringRecommendationComponent.GroveRecommendationType = this.groveRecommendationType;
    if(this.groveRecommendationType === 'as') {
      this.ASStandardOringSizes = this.getASStandardOringSizesData(this.aSStandardOringSizesService.oringSizesData);
    }else {
      this.ASStandardOringSizes = this.getASStandardOringSizesData(this.aSStandardOringSizesService.oringSizesJisData);
    }
    this.getSavedData();
  }

  initASStandardOringSizes() {
    if(OringRecommendationComponent.GroveRecommendationType === 'as') {
      this.groveRecommendationType = 'as';
      this.ASStandardOringSizes = this.getASStandardOringSizesData(this.aSStandardOringSizesService.oringSizesData);
    }else {
      this.groveRecommendationType = 'jis';
      this.ASStandardOringSizes = this.getASStandardOringSizesData(this.aSStandardOringSizesService.oringSizesJisData);
    }
  }

  selectAS($event) {
    const index = +$event.value + 1;
    this.selectedASStandardOringSize = null;
    if ($event.value !== '' && this.ASStandardOringSizes) {
      this.setOringSizeInputValues(this.ASStandardOringSizes[index], index);
    }
    this.selectEvent = $event;
    HomeComponent.isGrooveFormValid = $event.value >= 0;
    this.storageSet = false;
  }

  setOringSizeInputValues(OringSize = null, key?) {
    const defaultValue = 0..toFixed(this.getFixedCount());
    if (OringSize && key) {
      this.specialtiesSelected = key - 1;
      this.selectedASStandardOringSize = OringSize;
    }
    this.oringDefaults.oringSizeCsTol = this.getGroveInputValue('CS Tolerance-', OringSize).toFixed(this.getFixedCount()) || defaultValue;
    this.oringDefaults.oringSizeID = this.getGroveInputValue('ID-', OringSize).toFixed(this.getFixedCount()) || defaultValue;
    this.oringDefaults.oringSizeIDTol = this.getGroveInputValue('ID Tolerance-', OringSize).toFixed(this.getFixedCount()) || defaultValue;
    this.oringDefaults.oringSizeCs = this.getGroveInputValue('CS-', OringSize).toFixed(this.getFixedCount()) || defaultValue;
    this.fixedASStandardOringSize();
    if (OringSize && key) {
      this.updateLabels();
    }
  }

  fixedASStandardOringSize() {
    if(!this.selectedASStandardOringSize) {
      return;
    }
    const count = this.getFixedCount();
    this.selectedASStandardOringSize['CS Tolerance-M'] = (+this.selectedASStandardOringSize['CS Tolerance-M']).toFixed(count);
    this.selectedASStandardOringSize['CS-M'] = (+this.selectedASStandardOringSize['CS-M']).toFixed(count);
    this.selectedASStandardOringSize['ID Tolerance-M'] = (+this.selectedASStandardOringSize['ID Tolerance-M']).toFixed(count);
    this.selectedASStandardOringSize['ID-M'] = (+this.selectedASStandardOringSize['ID-M']).toFixed(count);
  }

  getGroveInputValue(name: string, data?) {
    if (this.selectedASStandardOringSize || this.ASStandardOring) {
      const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
      if (data == null) {
        data = this.ASStandardOring;
      }
      return +data[name + unitSystem];
    }
    return 0;
  }

  initImportedData() {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    const as = this.ASStandardOringSizes.find( item => {
      return +item['ID-' + unitSystem] == +this.oringDefaults.oringSizeID &&
        +item['CS-' + unitSystem] == +this.oringDefaults.oringSizeCs;
    });
    this.selectedASStandardOringSize = as;
    this.updateLabels();
  }

  getASbyIDAndCS() {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    let key;
    const as = this.ASStandardOringSizes.find((item, index) => {
      key = index;
      return +item['ID-' + unitSystem] == +this.oringDefaults.oringSizeID &&
        +item['CS-' + unitSystem] == +this.oringDefaults.oringSizeCs;
    });
    if (as) {
      this.setOringSizeInputValues(as, key);
      this.grooveRecErrorMsg = false;
    }else {
      if (HomeComponent.isGrooveFormValid) {
        this.grooveRecErrorMsg = 'For custom size O-ring, please consult ASNA application Engineers for most accurate groove recommendation.';
      }
      return false;
    }
    return as;
  }

  estimateGrooveSize() {
    this.formService.setTouched(this.form);
    this.checkForm(this.form);
    this.formService.setFocus('grooveInputs');
    if (!this.getASbyIDAndCS() || !this.selectedASStandardOringSize) {
      return;
    }
    if(RecommendationType[this.parentComponent.recommendationType] !== 'design_validation') {
      this.dataToSaveService.clearedData = false;
    }
    this.parentComponent.recommendations.activateOring = true;
    this.parentComponent.recommendations.activateGroove = true;
    this.parentComponent.recommendations.activateDesign = true;
    this.parentComponent.estimateGrooveSize = true;
    this.getGrooveRecommendationItemByAS(this.selectedASStandardOringSize.text);
    if(this.parentComponent.oringComp.form.valid) {
      HomeComponent.isOringFormValid = true;
    }
    this.parentComponent.oringComp.oringRecErrorMsg = false;
    this.parentComponent.grooveEstimated = true;
    this.trackingService.grooveEstimated(UnitSystem.getTypeByUnit(this.measurementUnit));
  }

  getGrooveRecommendationItemByAS(as: string) {
    const selectedAS = as;
    let data;
    if(this.groveRecommendationType === 'as') {
      as = String(as).replace('-', '');
      data = this.grooveRecommendationList.filter(item => {
        const ASStandardNo = item['ASStandardNo'].split('-');
        return +as >= +ASStandardNo[0] && +as <= +ASStandardNo[1];
      });
    }else {
      const jisType = selectedAS[0];
      as = String(as).replace(jisType, '');
      data = this.oringRecommendationListJis.filter(item => {
        const ASStandardNo = item['ASStandardNo'].split('-');
        const min = String(ASStandardNo[0]).replace(jisType, '');
        const max = String(ASStandardNo[1]).replace(jisType, '');
        return ASStandardNo[0][0] === jisType && +as >= parseInt(min) && +as <= parseInt(max)
      });
    }
    this.oringRecommendationEmiter.emit({'data': data, 'selectedAS': selectedAS});
  }

  checkForm(oringForm: NgForm) {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    for (const input in oringForm.value) {
      if ((input === 'oringSizeIDTol' || input === 'oringSizeCsTol') && !oringForm.value[input]) {
        continue;
      }
      if (oringForm.value[input] > this.setRange(input , 'max') || oringForm.value[input] <= this.setRange(input , 'min')) {
        oringForm.controls[input].setErrors({'rangeError': true});
      }
    }
    if (oringForm.valid && oringForm.touched) {
      HomeComponent.isGrooveFormValid = true;
      setTimeout(() => {
        this.parentComponent.customOringData = {
          [`CS-${unitSystem}`]: oringForm.value.oringSizeCs,
          [`CS Tolerance-${unitSystem}`] : oringForm.value.oringSizeCsTol,
          [`ID-${unitSystem}`]: oringForm.value.oringSizeID,
          [`ID Tolerance-${unitSystem}`]: oringForm.value.oringSizeIDTol
        };
      });

    }else {
      HomeComponent.isGrooveFormValid  = false;
    }
  }

  getErrorMsg(element, inputName) {
    if (element.errors && element.touched) {
      if (element.errors.required) {
        return 'Please fill in this field.';
      }
      if (element.errors.rangeError) {
        return `Invalid input. Typical value range: ${this.setRange(inputName, 'min')} - ${this.setRange(inputName, 'max')} ${this.measurementUnit}`;
      }
    }
    return false;
  }

  clearOringData () {
    this.selectedASStandardOringSize = null;
    this.grooveRecErrorMsg = false;
    this.ASStandardOring = null;
    this.setOringSizeInputValues();
    this.getGroveInputValue('');
    this.getData();
    this.setLabelDefaultValue();
    this.parentComponent.grooveEstimated = false;
    HomeComponent.isGrooveFormValid = false;
    this.formService.clearErrors(this.form);
    if (this.specialtiesSelected || this.specialtiesSelected === 0) {
      this.specialtiesSelected = '-CUSTOM';
    }
  }

  cancelEvent () {
    clearInterval(this.clickInterval);
  }

  changeInputValue(e, input, label = null) {
    if (!Number(input.value) && Number(input.value) !== 0) return;
    const model = e.model;
    let currentStep = 0.001;
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    if (unitSystem === 'M') {
      currentStep = 0.01;
    }
    let stopIncrease = false;
    let stopDecrement = false;
    const fixedCount = this.getFixedCount();

    this.clickInterval = setInterval(() => {
      if (e.operation === 'increment' && !stopIncrease) {
        stopDecrement = false;
        if (this.oringDefaults[model] >= this.setRange(e.model, 'max')) {
          stopIncrease = true;
          return;
        }
        const n = +this.oringDefaults[model] + currentStep;
        this.oringDefaults[model] = n.toFixed(fixedCount);
      }else if (e.operation === 'decrement' && !stopDecrement) {
        stopIncrease = false;
        if (this.oringDefaults[model] <= this.setRange(e.model, 'min')) {
          stopDecrement = true;
          return;
        }
        const n = +this.oringDefaults[model] - currentStep;
        this.oringDefaults[model] = n.toFixed(fixedCount);
      }
      if (label) {
        this.changeLabel(label, this.oringDefaults[model]);
      }
      input.focus();
    }, 80);
  }

  getFixedCount() {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    if (unitSystem === 'M') {
      return 2;
    }
    return 3;
  }

  changeLabel(key, value) {
    this.imageLabels[key] = value;
    if (this.specialtiesSelected !== '-CUSTOM' && this.specialtiesSelected !== undefined) {
      if (!this.storageSet) {
        AuthGuard.writeCookie('oringDefaults', JSON.stringify(this.oringDefaults));
        this.storageSet = true;
      }

      setTimeout(() => {
        this.specialtiesSelected = '-CUSTOM';
        const oringValues = JSON.parse(AuthGuard.readCookie('oringDefaults'));
        setTimeout(() => {
          this.oringDefaults.oringSizeID = oringValues.oringSizeID;
          this.oringDefaults.oringSizeIDTol = oringValues.oringSizeIDTol;
          this.oringDefaults.oringSizeCs = oringValues.oringSizeCs;
          this.oringDefaults.oringSizeCsTol = oringValues.oringSizeCsTol;
          AuthGuard.deleteCookieByName('oringDefaults');
        });
      }, 0);
    }
  }

  setLabelDefaultValue() {
    this.imageLabels = {
      id: 'ID',
      cs: 'CS'
    };
  }

  updateLabels() {
    for (const item in this.oringDefaults) {
      if (+this.oringDefaults[item] !== 0) {
        this.imageLabels.id = this.oringDefaults.oringSizeID;
        this.imageLabels.cs = this.oringDefaults.oringSizeCs;
        return;
      }
    }
    this.setLabelDefaultValue();
  }

  getSavedData(): void {
    const paths = this.dataToSaveService.getPaths();
    if (paths.length > 0 && paths[paths.length - 1] === 'saved-files') {
      this.getOringLimitations(this.measurementUnit, true);
      const activeSections = this.dataToSaveService.getActiveSections();
      if (activeSections && activeSections['activateGroove']) {
        const savedOringData = this.dataToSaveService.getOringInputs();
        if (Number(savedOringData.asCode) >= 0) {
          this.specialtiesSelected = savedOringData.asCode;
        } else {
          this.oringDefaults = savedOringData.oringInputs;
        }
        this.updateLabels();
      }
      this.dataToSaveService.clearData();
    } else {
      this.getOringLimitations();
    }
  }

  getImportedData(importedData: string[], recommendationType: string): void {
    const asNumber = importedData[0].trim().split(' ')[1];
    const as = this.ASStandardOringSizes.find((item) => {
      return item.text == asNumber;
    });
    setTimeout(()=> {
      this.oringDefaults = {
        oringSizeID: importedData[1],
        oringSizeIDTol: importedData[2],
        oringSizeCs: importedData[3],
        oringSizeCsTol: importedData[4]
      };
      this.updateLabels();
    });
    if(!as) {
      this.specialtiesSelected = '-CUSTOM';
    }else {
      this.specialtiesSelected = as.id;
    }
    if(recommendationType === 'oring_recommendation') {
      this.parentComponent.recommendationType = 0;
    }else if(recommendationType === 'groove_recommendation') {
      this.parentComponent.recommendationType = 1;
    }else if(recommendationType === 'design_validation') {
      this.parentComponent.recommendationType = 2;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/groove-recommendation/groove-recommendation.component.ts